import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { IconButton } from 'components/IconButton/IconButton'
import ItemStyles from 'components/CollabItem/CollabItem.module.scss'
import { Menu } from 'components/Menu/Menu'
import { Item as MenuItem } from '@react-stately/collections'
import { Rename } from 'almanac-ui/icons'
import { Comment } from 'types'
import { MoreDots } from 'blaze-ui/icons'
import { useCommentPermissions } from 'components/CommentV2/useCommentPermissions'
import { Key, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { useCollabItemContext } from 'components/CollabItem/CollabItem'
import { useThreadContext } from 'components/CommentV2/Thread/Thread'
import { ReactComponent as EditIcon } from 'assets/icons/edit16.svg'
import { ReactComponent as TrashIcon } from 'assets/icons/trash16.svg'

interface Props {
  comment: Comment
}

export const CommentOptionsMenu = observer(({ comment }: Props) => {
  const rootStore = useRootStore()
  const { canEdit, canRename, canDelete } = useCommentPermissions(comment)
  const { setEditing } = useCollabItemContext()
  const { setRenaming } = useThreadContext()
  const disabledKeys = useMemo(() => {
    const disabledKeys = new Set<string>()
    if (!canEdit) disabledKeys.add('edit')
    if (!canRename) disabledKeys.add('rename')
    if (!canDelete) disabledKeys.add('delete')
    return disabledKeys
  }, [canEdit, canRename, canDelete])

  const handleAction = (action: Key) => {
    switch (action) {
      case 'edit':
        setEditing({ type: 'comment', id: comment.id })
        rootStore.comments.select(comment.id)
        break
      case 'rename':
        setRenaming(true)
        break
      case 'delete':
        rootStore.comments.delete(comment.id, { trackArticleUpdate: true })
        break
    }
  }

  return (
    <MenuTrigger placement="bottom-end">
      <IconButton icon={MoreDots} aria-label="More actions" className={ItemStyles.controlItem} />
      <div
        style={{
          pointerEvents: 'auto',
        }}
      >
        <Menu aria-label="More actions" disabledKeys={disabledKeys} onAction={handleAction}>
          <MenuItem key="edit" textValue="Edit">
            <EditIcon />
            Edit
          </MenuItem>
          <MenuItem key="rename" textValue="Name this thread">
            <Rename />
            {comment.title ? 'Rename this thread' : 'Name this thread'}
          </MenuItem>
          <MenuItem key="delete" textValue="Delete">
            <TrashIcon />
            Delete
          </MenuItem>
        </Menu>
      </div>
    </MenuTrigger>
  )
})
